// src/pages/RoleSelect.tsx
import { useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion'
import { Button } from '../components/ui/Button'
import { Card } from '../components/ui/Card'
import { useApp } from '../lib/store'
import { BunnyCharacter } from '../components/BunnyCharacter'

export function RoleSelect() {
  const navigate = useNavigate()
  const { setRole } = useApp()

  const handleParent = () => {
    setRole('parent')
    navigate('/parent')
  }

  const handleChild = () => {
    setRole('child')
    navigate('/parent') // Shows hunt list to pick which hunt to play
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-dvh p-6 pb-[calc(1.5rem+env(safe-area-inset-bottom,0px))] bg-cream">
      <BunnyCharacter size="lg" animate="bounce" />

      <h1 className="font-heading text-3xl text-ink mt-4 mb-8">Vem är du?</h1>

      <div className="flex flex-col gap-4 w-full max-w-sm">
        <motion.div whileTap={{ scale: 0.95 }}>
          <Card onClick={handleParent} className="text-center shadow-md active:shadow-sm transition-shadow">
            <p className="font-heading text-xl text-ink mb-1">Förälder</p>
            <p className="font-body text-base text-ink/60">Skapa och hantera jakter</p>
          </Card>
        </motion.div>

        <motion.div whileTap={{ scale: 0.95 }}>
          <Card onClick={handleChild} className="text-center shadow-md active:shadow-sm transition-shadow">
            <p className="font-heading text-xl text-ink mb-1">Barn</p>
            <p className="font-body text-base text-ink/60">Spela och hitta ägg!</p>
          </Card>
        </motion.div>
      </div>
    </div>
  )
}
